import styled from 'styled-components';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';

export const Link = styled(Text)({
  cursor: 'pointer',
  textDecoration: 'underline',
  color: 'inherit',
  fontWeight: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',

  '&:hover': {
    color: 'inherit',
  },
});
